module.exports = __webpack_public_path__ + "img/feet.4a69ac89.png";